import { textToHtml } from '../utils/emailFormatting.js';

export const generateAmandaAnalysis = (artistData) => {
  const { gems_data, tracks_data, artists_data, history_data } = artistData;
  // Extract name from nested artists_data or top level
  const artistName = artistData.name || artistData.artists_data?.name;

  const content = `Hey Alex,

Quick flag on ${artistName}.

Top Track: ${tracks_data?.top_track || 'Unknown'}

STATS:
Spotify Plays: ${formatNumber(tracks_data?.spotify_plays)}
Spotify Monthly Listeners: ${formatNumber(artistData.spotify_monthly_listeners)}
Spotify Followers: ${formatNumber(artistData.spotify_followers)}
TikTok Followers: ${formatNumber(artistData.tiktok_followers)}
Instagram Followers: ${formatNumber(artistData.instagram_followers)}
YouTube Subscribers: ${formatNumber(artistData.youtube_subs || history_data?.youtube_subs)}
YouTube Monthly Views: ${formatNumber(artistData.youtube_monthly_views || history_data?.youtube_monthly_views)}
TikTok Top Video Views: ${formatNumber(artistData.tiktok_top_video_views || history_data?.tiktok_top_video_views)}
Shazam Count: ${formatNumber(artistData.shazam_count || history_data?.shazam_count)}
Spotify Playlist Reach: ${formatNumber(artistData.spotify_playlist_reach || history_data?.sp_playlist_total_reach)}
Spotify Playlist Count: ${formatNumber(artistData.spotify_playlist_count || history_data?.spotify_playlist_count)}
Spotify Daily Growth Rate: ${formatPercent(artistData.spotify_growth_rate || history_data?.spotify_growth_rate)}
Instagram Engagement Rate: ${formatPercent(artistData.instagram_engagement_rate || history_data?.instagram_engagement_rate)}

REGRESSION ANALYSIS:
${artistData.readout_text || 'Pre-analysis artist - crawled from Instagram discovery'}

Momentum Score: ${describeMomentum(artistData.momentum_score)}
Predicted Growth: ${describePredictedGrowth(artistData.predicted_growth)}
Priority Score: ${describePriority(artistData.priority_score)}

Spotify: ${(artistData.spotify_url || artists_data?.spotify_url)?.split('?')[0] || 'N/A'}
Instagram: ${(artistData.instagram_url || artists_data?.instagram_url)?.split('?')[0] || 'N/A'}
Email: ${artistData.email || artistData.best_email || artists_data?.email || 'N/A'}

Kinda reminds me of ${artistData.reference_artist_2_name || artistData.reference_artist_name || 'one of our recent wins'} — want me to queue outreach?

Amanda Goldfarb

(718) 555-0142
Executive Assistant / Data Analyst
https://freshlybakedstudios.com
@amandagoldfarb`;

  return {
    subject: `Quick Flag — ${artistName}`,
    from: "goldfarb@freshlybakedstudios.com",
    to: "almgren@freshlybakedstudios.com",
    content,
    htmlContent: textToHtml(content)
  };
};

function formatNumber(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return 'N/A';
  }
  return Number(value).toLocaleString();
}

function describeMomentum(value) {
  const num = Number(value);
  if (Number.isNaN(num)) {
    return 'N/A';
  }
  let label;
  if (num >= 8) {
    label = 'Explosive – top breakout velocity';
  } else if (num >= 6) {
    label = 'High – cross-platform acceleration';
  } else if (num >= 4) {
    label = 'Emerging – momentum building';
  } else {
    label = 'Early signals – nurture potential';
  }
  return `${num.toFixed(1)} (${label})`;
}

function describePredictedGrowth(value) {
  const num = Number(value);
  if (Number.isNaN(num)) {
    return 'N/A';
  }
  const pct = Math.max(0, Math.min(num, 1)) * 100;
  let label;
  if (pct >= 75) {
    label = 'Breakout probability: very high';
  } else if (pct >= 55) {
    label = 'Breakout probability: strong';
  } else if (pct >= 40) {
    label = 'Breakout probability: developing';
  } else {
    label = 'Breakout probability: monitor';
  }
  return `${pct.toFixed(0)}% (${label})`;
}

function describePriority(value) {
  const num = Number(value);
  if (Number.isNaN(num)) {
    return 'N/A';
  }
  let label;
  if (num >= 8) {
    label = 'High priority 🔥 outreach-ready';
  } else if (num >= 6) {
    label = 'Medium priority ⚡ queue soon';
  } else {
    label = 'Foundation priority ✨ nurture list';
  }
  return `${num.toFixed(1)} (${label})`;
}

function formatPercent(value, digits = 1) {
  const num = Number(value);
  if (Number.isNaN(num)) {
    return 'N/A';
  }
  const scaled = Math.abs(num) <= 1 ? num * 100 : num;
  return `${scaled.toFixed(digits)}%`;
}
